export default function translate(i18n, propriete) {
  if (propriete === 'code') return i18n.t('addEditParution.information.code');
  if (propriete === 'nomParution') return i18n.t('addEditParution.information.nomParution');
  if (propriete === 'numParution') return i18n.t('addEditParution.information.numParution');
  if (propriete === 'dateRemiseEltTech') return i18n.t('addEditParution.information.dateRemiseEltTech');
  if (propriete === 'dateRemiseEltTech') return i18n.t('addEditParution.information.dateRemiseEltTech');
  if (propriete === 'dateRemiseEltTech') return i18n.t('addEditParution.information.dateRemiseEltTech');
  if (propriete === 'dateParution') return i18n.t('addEditParution.information.dateParution');
  if (propriete === 'qteACreer') return i18n.t('listeParution.generationParutions.qteACreer');
  if (propriete === 'produitId') return i18n.t('addEditParution.information.produit');
  if (propriete.startsWith('pages')) {
    const prefixI18n = 'addEditParution.error.';
    if (propriete.endsWith('ordre')) return i18n.t(`${prefixI18n}ordre`);
    if (propriete.endsWith('Nom')) return i18n.t(`${prefixI18n}nom`);
    if (propriete.endsWith('LargeurUtile')) return i18n.t(`${prefixI18n}largeurUtile`);
    if (propriete.endsWith('HauteurUtile')) return i18n.t(`${prefixI18n}hauteurUtile`);
    if (propriete.endsWith('Largeur')) return i18n.t(`${prefixI18n}largeur`);
    if (propriete.endsWith('Hauteur')) return i18n.t(`${prefixI18n}hauteur`);
    if (propriete.endsWith('MargeGauche')) return i18n.t(`${prefixI18n}margeGauche`);
    if (propriete.endsWith('MargeHaute')) return i18n.t(`${prefixI18n}margeHaute`);
    if (propriete.endsWith('SurfaceId')) return i18n.t(`${prefixI18n}surface`);
    if (propriete.endsWith('EmplacementId')) return i18n.t(`${prefixI18n}emplacement`);
    if (propriete.endsWith('CouleurEncartId')) return i18n.t(`${prefixI18n}couleurEncart`);
  }
  return propriete;
}
